import React from 'react';
import { Divider, Flex } from 'antd';
import { DEVIATION_ROW_ID } from '../../constants/SitePerformanceChart.constants';
import { buildTooltipRows } from '../../utils/SitePerformanceChartTooltipUtils';
import { SitePerformanceChartTooltipProps } from './SitePerformanceChartTooltip.types';
import { kccThemeConstants } from 'config/theme/kccTheme/kccTheme';
import { ReactChartUtils } from 'app/utils/react-charts/ReactChartUtils';

export const SitePerformanceChartTooltip = (props: SitePerformanceChartTooltipProps): JSX.Element => {
  const { siteIndex, pageActualData, subtitle, t } = props;
  const title = ReactChartUtils.extractColumnName(pageActualData[siteIndex]?.primary);
  const rows = buildTooltipRows(props);

  return (
    <Flex className="site-performance-chart__tooltip" vertical gap={kccThemeConstants.SPACING.SM}>
      <Flex vertical>
        <p className="site-performance-chart__tooltip-title">{title}</p>
        <p className="site-performance-chart__tooltip-subtitle">{subtitle}</p>
      </Flex>

      <Flex vertical gap={kccThemeConstants.SPACING.SM}>
        {rows.map(row => (
          <React.Fragment key={row.seriesId}>
            {row.seriesId === DEVIATION_ROW_ID && <Divider className="site-performance-chart__tooltip-divider" />}
            <Flex align="center" justify="space-between" style={{ width: '100%' }}>
              <Flex align="center" gap={kccThemeConstants.SPACING.XS}>
                <div
                  className="site-performance-chart__tooltip-item-square-icon"
                  style={{ backgroundColor: row.colorSquareIcon }}
                />
                <p className="site-performance-chart__tooltip-item-seriesLabel">{`${t(row.seriesLabel)}`}</p>
              </Flex>

              <Flex align="center" justify="space-between" gap={kccThemeConstants.SPACING.XS} style={{ minWidth: 110 }}>
                <p className="site-performance-chart__tooltip-item-hours">{row.hoursTitle}</p>
                <p className="site-performance-chart__tooltip-item-percent">{row.percent}</p>
              </Flex>
            </Flex>
          </React.Fragment>
        ))}
      </Flex>
    </Flex>
  );
};
